import type React from "react"
import { useState, type MouseEvent } from "react"
import { IconButton, Popover, Typography, Box, useTheme } from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"

interface InfoPopoverProps {
    content: React.ReactNode
    title?: string
}

export default function InfoPopover({ content, title }: InfoPopoverProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
    const theme = useTheme()
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? "info-popover" : undefined

    return (
        <>
            <IconButton aria-describedby={id} onClick={handleClick} size="small" sx={{ color: theme.palette.blueColors.main }}>
                <InfoIcon fontSize="small" />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Box sx={{ p: 2, maxWidth: 300 }}>
                    {/* {title && (
                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                            {title}
                        </Typography>
                    )} */}
                    <Typography variant="body2">{content}</Typography>
                </Box>
            </Popover>
        </>
    )
}

